export default __webpack_public_path__ + "static/media/wintersbite.60e7fac1.png";